import './map.css';
import "leaflet/dist/leaflet.css";
import React, { Component } from 'react';
import { Map, ScaleControl, TileLayer, CircleMarker, Popup, Polyline, Tooltip, GeoJSON } from 'react-leaflet';
import WindDirectionArrow from './wind-direction-arrow.svg';
import MainPlayer from './mainPlayer';
import CalcLine from './calcLine';
import TurnMark from './TurnMark';
import WindLine from './WindLine';
import { connect } from "react-redux";
import { main } from "../../actions";
import { isSailingLike } from "../../dispMode";

class MapBrowser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pos: this.props.pos,
      zoom: this.props.zoom,
      windLine: false,
    };

    this.handleClickWindLine = this.handleClickWindLine.bind(this);
  }

  handleClickWindLine() {
    this.setState({ windLine: !this.state.windLine });
  }

  reLoadMap() {
    if (this.refs.map) {
      this.refs.map.leafletElement.invalidateSize();
      this.props.reloadMap({ _isMapReload: false });
    }
  }

  render() {
    if (this.props.isMapReload) {
      this.reLoadMap();
    }
    this.reLoadMap();

    const { authUser } = this.props;
    const isSailing = isSailingLike(authUser && authUser.organization && authUser.organization.event);

    const WindLines = Object.keys(this.props.deviceMap).map((key, index) => (
      <WindLine
        key={index}
        lineLength={1000}
        windDir={this.props.windDirection}
        pos={this.props.deviceMap[key].pos}
      />
    ));

    return (
      <div className='map-view' style={{ position: 'relative' }}>
        {/* WIND 表示 */}
        <div className="leaflet-top leaflet-right">
          <div className="leaflet-control wind-direction-icon" style={{ padding: 0 }}>
            <span className='top-label'>WIND</span>
            <span className='arrow-label'>
              <img
                alt="Wind"
                className="arrow-img"
                src={WindDirectionArrow}
                style={{ transform: `rotateZ(${this.props.windDirection}deg)` }}
              />
            </span>
            <span className='bottom-label wind-unit'>
              {this.props.windSpeed} {this.props.authUser.wind_unit}
            </span>
          </div>
        </div>

        {/* 風線表示切り替えチェックボックス */}
        <div className="leaflet-top leaflet-left" style={{ marginTop: '50px' }}>
          <div className="leaflet-control">
            <label style={{ color: 'black' }}>
              <input
                type="checkbox"
                checked={this.state.windLine}
                onChange={this.handleClickWindLine}
              /> Show Wind Lines
            </label>
          </div>
        </div>

        <Map
          ref="map"
          center={this.props.center}
          zoom={this.state.zoom}
          doubleClickZoom={true}
          attributionControl={false}
          style={{ height: '40vh' }}
          maxZoom={22}
        >
          <TileLayer
            attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            maxZoom={22}
            maxNativeZoom={19}
          />

          <ScaleControl position="bottomleft" imperial={false} />

          {Object.keys(this.props.deviceMap).map((key, index) => (
            <MainPlayer
              key={index}
              device={this.props.deviceMap[key]}
              keyNum={key}
              authUser={this.props.authUser}
              isSailing={isSailing}
              colorMode={this.props.colorMode}
              selectionRange={this.props.selectionRange}
            />
          ))}

          {this.state.windLine ? WindLines : null}

          <CalcLine calcLine={this.props.calcLine} />

          {(() => {
            let geojsonData = null;
            if (this.props.start_line) {
              if (typeof this.props.start_line === 'string') {
                try {
                  geojsonData = JSON.parse(this.props.start_line);
                } catch (e) {
                  console.error("Invalid GeoJSON string", e);
                }
              } else {
                geojsonData = this.props.start_line;
              }
            }
            return geojsonData && (
              <GeoJSON
                data={geojsonData}
                style={{ color: 'green', weight: 4, opacity: 0.9 }}
              />
            );
          })()}

          <TurnMark coordinate={this.props.buoy_coordinate} />

          {this.props.markers && this.props.markers.map((m, i) => (
            <CircleMarker
              key={i}
              center={[m.lat, m.lon]}
              color={m.color}
              fillColor={m.color}
              fillOpacity={1}
              radius={5}
            >
              <Popup>
                {m.label}: {m.value}
              </Popup>
            </CircleMarker>
          ))}

          {this.props.heightLine && (
            <React.Fragment>
              <Polyline
                positions={this.props.heightLine.pos}
                color="white"
                weight={3}
                opacity={0.8}
              />
              <CircleMarker
                center={[
                  (this.props.heightLine.pos[0][0] + this.props.heightLine.pos[1][0]) / 2,
                  (this.props.heightLine.pos[0][1] + this.props.heightLine.pos[1][1]) / 2
                ]}
                opacity={0}
                fillOpacity={0}
              >
                <Tooltip permanent direction="center" className="no-background-tooltip">
                  <span style={{ color: 'white', textShadow: '1px 1px 2px black', fontSize: '14px', fontWeight: 'bold' }}>
                    {this.props.heightLine.text}
                  </span>
                </Tooltip>
              </CircleMarker>
            </React.Fragment>
          )}
        </Map>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMapReload: state.Main.isMapReload,
  authUser: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  reloadMap: ({ _isMapReload }) => dispatch(main.reloadMap({ _isMapReload })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapBrowser);

